export const DEPARTMENT = {
    currentDepartment: 'currentDepartment',
    fashion: 'fashion',
};
